// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import { StyleSheet, Text, View } from '@react-pdf/renderer'
import PatientChartsPrintedFriendlySectionItemProperty from '../PatientChartsPrintedFriendlySectionItemProperty/PatientChartsPrintedFriendlySectionItemProperty'
import { renderPdfHtml } from '@quickmd-llc/frontend-utils/pdf'
import { stripSoapHeaders } from '../../../utils/noteHtmlSanitizer'

const styles = StyleSheet.create({
  separateLine: {
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: '#C2D5E2',
    borderBottomStyle: 'solid',
  },
  sectionSubTitle: {
    color: '#141414',
    textAlign: 'right',
    fontFamily: 'Helvetica-Bold',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: 16,
    marginTop: 16,
  },
  pastVisitSectionSubTitle: {
    color: '#141414',
    textAlign: 'left',
    fontFamily: 'Helvetica-BoldOblique',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: 16,
    marginTop: 16,
  },
  pastVisitSubSectionMessage: {
    color: '#767676',
    textAlign: 'left',
    fontFamily: 'Helvetica',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: 8,
    lineHeight: 1.3,
  },
})
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const PatientChartsPrintedFriendlyPastVisitNotes = ({ properties }) => (
  <View>
    {/*
     // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
    {properties.map(({ content, title }) => {
      const { pastVisitProperties, icd10Codes, pastVisitMainProperties, patientInstructions } = content || {}
      return (
        <View>
          <View>
            <Text style={styles.sectionSubTitle}>{title}</Text>
            {/*
             // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
            {pastVisitMainProperties?.map(({ name, value }) => (
              <PatientChartsPrintedFriendlySectionItemProperty name={name} value={value} />
            ))}
          </View>
          {/*
           // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
          {pastVisitProperties?.map(({ subtitleLabel, writtenBy, savedOn, noteMsg, isWithoutWrittenBy }) => (
            <View>
              <Text style={styles.pastVisitSectionSubTitle}>{subtitleLabel}</Text>
              {!!writtenBy && !isWithoutWrittenBy && (
                <PatientChartsPrintedFriendlySectionItemProperty name='Written by' value={writtenBy} />
              )}
              <PatientChartsPrintedFriendlySectionItemProperty name='Saved on' value={savedOn} />
              <View>{renderPdfHtml(stripSoapHeaders(noteMsg), styles.pastVisitSubSectionMessage)}</View>
            </View>
          ))}
          <View>
            {icd10Codes?.length > 0 && <Text style={styles.pastVisitSectionSubTitle}>ICD-10 codes</Text>}
            {/*
             // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
            {icd10Codes?.map(({ code, codeMsg }) => (
              <View>
                <Text style={styles.pastVisitSubSectionMessage}>{code}</Text>
                <Text style={styles.pastVisitSubSectionMessage}>{codeMsg}</Text>
              </View>
            ))}
          </View>
          {patientInstructions?.map(
            // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
            ({ subtitleLabel, writtenBy, savedOn, patientInstructionMsg, isWithoutWrittenBy }) => (
              <View>
                <Text style={styles.pastVisitSectionSubTitle}>{subtitleLabel}</Text>
                {!!writtenBy && !isWithoutWrittenBy && (
                  <PatientChartsPrintedFriendlySectionItemProperty name='Written by' value={writtenBy} />
                )}
                <PatientChartsPrintedFriendlySectionItemProperty name='Saved on' value={savedOn} />
                <View>{renderPdfHtml(stripSoapHeaders(patientInstructionMsg), styles.pastVisitSubSectionMessage)}</View>
              </View>
            ),
          )}
        </View>
      )
    })}
  </View>
)

export default PatientChartsPrintedFriendlyPastVisitNotes
